var path = '/registration/form/form-field-richtext.html';
var html = "<div ng-bind-html=\"$ctrl.descriptionHtml\"></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;